<template>
  <v-dialog width="500" v-model="dialog">
    <template v-slot:activator="{on}">
      <v-btn text color="success" v-on="on">select</v-btn>
    </template>
    <v-card>
      <v-card-title>{{title}}</v-card-title>
      <v-divider />
      <v-card-text>
        <v-text-field class="mt-2" placeholder="Search" outlined v-model="search" prepend-inner-icon="mdi-magnify"/>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text v-on:click="dialog = false">cancel</v-btn>
        <v-btn text color="success">done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Items from '../../mixins/items'
export default {
  name: 'v-select-items',
  mixins: [Items],
  data: () => ({
    dialog: false,
    search: '',
    title: 'Select items'
  })
}
</script>